<template>
  <div class="card-company-plan">
    <div
      class="card-company-plan-link"
      :class="{
        'card-company-plan-link--full': !enableSwitch,
        'card-company-plan--disabled': collaboratorHasServiceProfessional,
      }"
    >
      <button
        class="card-company-plan__header"
        @click="routerPage(collaborator)"
      >
        <p>
          {{ collaborator.name }}
        </p>
        <div
          class="card-company-plan__status"
          :class="{
            'card-company-plan__status--active': collaborator.is_active,
          }"
        >
          <template v-if="collaborator.is_active"> Ativado </template>
          <template v-else> Desativado </template>
        </div>
      </button>
      <button class="card-company-plan__text" @click="routerPage(collaborator)">
        <p>
          Empresa: <b>{{ collaborator.company_name }}</b>
        </p>
        <p>
          Departamento: <b>{{ collaborator.department_name }}</b>
        </p>
      </button>
      <template v-if="enableSwitch">
        <div
          class="content-switch"
          :class="{ 'card-company-plan--disabled': !collaborator.is_active }"
        >
          <div class="content-switch__div">
            <p class="content-switch__text">
              Atendimento ao colaborador:
              <strong>
                <template
                  v-if="
                    collaborator.is_active_professional_has_company_collaborators
                  "
                >
                  Ativado
                </template>
                <template v-else> Desativado </template>
              </strong>
            </p>
            <label class="switch">
              <input
                type="checkbox"
                name="is_active"
                :checked="
                  collaborator.is_active_professional_has_company_collaborators
                "
                @click.prevent="handleChangeSwitch"
              />
              <span class="slider round"></span>
            </label>
          </div>
          <p
            v-if="!collaborator.is_active"
            class="content-switch__text-disabled"
          >
            Desativado porque o colaborador não está ativo.
          </p>
        </div>
        <div
          v-if="collaboratorHasServiceProfessional"
          class="card-company-plan__has-service"
        >
          Colaborador está sendo atendido pelo o profissonal:
          <span>
            {{
              collaboratorHasServiceProfessional.code_name ||
              collaboratorHasServiceProfessional.name
            }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    collaborator: {
      type: Object,
      required: true,
    },
    enableSwitch: {
      type: Boolean,
      default: false,
    },
    professionalDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasCompanyCollaboratorsWithServiceProfessional() {
      return (
        this.professionalDetails?.companyCollaboratorsWithServiceProfessional &&
        Array.isArray(
          this.professionalDetails.companyCollaboratorsWithServiceProfessional
        ) &&
        this.professionalDetails.companyCollaboratorsWithServiceProfessional
          .length
      );
    },
    collaboratorHasServiceProfessional() {
      if (!this.hasCompanyCollaboratorsWithServiceProfessional) {
        return false;
      }

      const professionalWithCollaborator =
        this.professionalDetails.companyCollaboratorsWithServiceProfessional.find(
          (item) => item.id_company_collaborators === this.collaborator.id
        );

      if (
        !professionalWithCollaborator ||
        this.professionalDetails.professional.id ===
          professionalWithCollaborator.id
      ) {
        return false;
      }

      return professionalWithCollaborator;
    },
  },
  data() {
    return {
      switchIsActive: false,
    };
  },
  methods: {
    ...mapActions("Company", ["updateProfessionalHasCompanyCollaborators"]),
    ...mapActions(["getSlugify"]),
    async routerPage(collaborator) {
      this.$router.push({
        name: "EditCollaboratorCompany",
        params: {
          id: collaborator.id_company,
          idCompanyCollaborator: collaborator.id,
          slug: await this.getSlugify(collaborator.company_name),
        },
      });
    },
    async handleChangeSwitch(event) {
      console.log(event.target.checked);
      const isChecked = event.target.checked;
      const status = isChecked ? "ATIVAR" : "DESATIVAR";
      const statusAfter = isChecked ? "ATIVADO" : "DESATIVADO";
      const professionalName =
        this.professionalDetails.professional.code_name ||
        this.professionalDetails.professional.name;

      const result = await this.$swal.fire({
        html: `Tem certeza que deseja <b>${status}</b> o atendimento do profissional <b>${professionalName}</b> no colaborador
        <b style=" display: block; font-size: 24px; color: #EF0000;">${this.collaborator.name}?</b>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#EF0000",
        confirmButtonText: "SIM",
        cancelButtonText: "NÃO",
      });

      if (result.isConfirmed) {
        const payload = {
          id_company: this.$route.params.id,
          id_professional: this.professionalDetails.professional.id,
          id_company_collaborators: this.collaborator.id,
          is_active: isChecked,
        };

        if (this.collaborator.id_professional_has_company_collaborators) {
          payload.id =
            this.collaborator.id_professional_has_company_collaborators;
        }

        await this.updateProfessionalHasCompanyCollaborators(payload);

        this.$swal.fire({
          icon: "success",
          html: `Atendimento do profissional <b>${professionalName}</b> no colaborador <b>${this.collaborator.name}</b> foi <b>${statusAfter}</b> com sucesso!`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-company-plan {
  position: relative;
  min-height: 200px;
  display: block;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  &-link {
    height: 100%;
    transition: 500ms;
    &:hover,
    &:focus {
      cursor: pointer;
      opacity: 0.8;
    }
    &--full {
      display: grid;
      grid-template-rows: 61px 2fr;
      .card-company-plan__text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
  &__text {
    width: 100%;
    padding: 15px;
    text-align: left;
    background: 0;
    border: 0;
    p {
      font-size: 16px;
      font-family: "Font Regular";
      color: var(--black);
      margin-bottom: 0;
    }
  }
  &__header {
    width: 100%;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: 0;
    border: 0;
    border-bottom: 1px solid var(--gray-light);
    p {
      font-size: 20px;
      font-family: "Font Bold";
      color: var(--black);
      max-width: 210px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-bottom: 0;
    }
  }
  &-btn {
    padding: 15px;
    .btn-yellow {
      margin-bottom: 0;
    }
  }
  &__status {
    width: max-content;
    background: var(--yellow-dark);
    padding: 5px 15px;
    border-radius: 30px;
    font-family: "Font Semibold";
    color: var(--white);
    font-size: 12px;
    &--active {
      background: var(--green-2);
    }
  }
  &__has-service {
    padding: 10px 15px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0 0 10px 10px;
    font-size: 14px;
    font-family: "Font Regular";
    color: var(--green-dark);
    margin-top: 10px;
    span {
      font-family: "Font Bold";
    }
  }
  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  .content-switch {
    padding: 0 15px;
    &__div {
      display: flex;
      align-items: center;
    }
    &__text {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      margin-right: 10px;
      margin-bottom: 0;
      &-disabled {
        font-size: 10px;
        font-family: "Font Light";
        color: var(--red-dark);
        padding: 10px 0;
      }
    }
    .switch {
      position: relative;
      display: inline-block;
      width: 51px;
      height: 26px;
      margin-bottom: 0;
    }
    /* Hide default HTML checkbox */
    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }
    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: var(--red-dark);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
    .slider:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 3px;
      bottom: 3px;
      background-color: var(--white);
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
    input:checked + .slider {
      background-color: var(--green);
    }
    input:checked + .slider:before {
      -webkit-transform: translateX(25px);
      -ms-transform: translateX(25px);
      transform: translateX(25px);
    }
    /* Rounded sliders */
    .slider.round {
      border-radius: 20px;
    }
    .slider.round:before {
      border-radius: 100%;
    }
  }
}
</style>
